/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  SettleTransactionsSettlementsOptions,
  SettleTransactionsSettlementsResponses,
} from '../types/SettleTransactionsSettlements'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Settle multiple transactions settlements in batch
 * {@link /v1/transactions/settlements}
 */
export function settleTransactionsSettlements<ThrowOnError extends boolean = true>(
  options: Options<SettleTransactionsSettlementsOptions, ThrowOnError>,
): Unwrappable<RequestResult<SettleTransactionsSettlementsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/transactions/settlements',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<SettleTransactionsSettlementsResponses, ThrowOnError>>,
  )
}
